import { Component, Input } from '@angular/core';
import { Message } from "../shared/models/message.model";
import { MatDialog } from "@angular/material/dialog";
import { MessageDetailComponent } from "../message-detail/message-detail.component";
import { DetailOpenMode } from "../../devices/shared/models/device-types-attributes";

@Component({
  selector: 'app-message-card',
  templateUrl: './message-card.component.html',
  styleUrls: ['./message-card.component.scss']
})
export class MessageCardComponent {
  @Input() message!: Message;

  constructor(
    private dialog: MatDialog
  ) {
  }

  protected openDetails(
    event: Event,
    openMode = DetailOpenMode.REGULAR
  ): void {
    event.stopPropagation();

    this.dialog.open(MessageDetailComponent, {
      panelClass: ['mat-dialog-override', 'dialog-responsive'],
      data: {
        itemData: this.message,
        openMode
      },
    });

  }
}
